module.exports = __webpack_public_path__ + "static/img/bg.7e20c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 0